(function (scope) {
  'use strict';

  function create(options) {
    var active = null;
    var pending = null;
    var completed = null;
    var key = options.key;
    var storage = options.storage;
    try {
      var saved = JSON.parse(storage.getItem(key) || 'null');
      if (saved && typeof saved.body === 'string' && saved.body.length < 200000) {
        var parsed = JSON.parse(saved.body);
        if (typeof parsed.submissionToken === 'string' && /^[0-9a-f-]{36}$/i.test(parsed.submissionToken)) pending = saved;
      }
    } catch (_) {}

    function submit(payload) {
      if (active) return active;
      if (completed) return Promise.resolve(completed);
      if (!pending) {
        var body = JSON.stringify(Object.assign({}, payload, { submissionToken: options.uuid() }));
        pending = { body: body };
        try {
          storage.setItem(key, JSON.stringify(pending));
        } catch (_) {
          pending = null;
          return Promise.resolve({ ok: false, code: 'STORAGE_UNAVAILABLE' });
        }
      }
      var controller = new AbortController();
      var timer;
      var timeout = new Promise(function (_, reject) {
        timer = setTimeout(function () {
          controller.abort();
          reject(new Error('timeout'));
        }, options.timeoutMs || 15000);
      });
      active = Promise.race([
        Promise.resolve().then(function () {
          return options.fetch(options.endpoint, {
            method: 'POST', credentials: 'omit', redirect: 'error',
            headers: { 'Content-Type': 'application/json' },
            body: pending.body, signal: controller.signal
          }).then(async function (response) {
            var data = await response.json();
            if (controller.signal.aborted) return { ok: false, code: 'RETRY', frozen: true };
            if (response.ok && data.success === true && typeof data.inquiryNumber === 'string' && data.inquiryNumber.length > 0 && data.inquiryNumber.length <= 100) {
              completed = { ok: true, inquiryNumber: data.inquiryNumber };
              try { storage.removeItem(key); } catch (_) {}
              pending = null;
              return completed;
            }
            if (response.status === 422 && data.error && data.error.code === 'VALIDATION_ERROR') {
              if (data.error.fields && data.error.fields.submissionToken) return { ok: false, code: 'CONFLICT', frozen: true };
              try { storage.removeItem(key); } catch (_) {}
              pending = null;
              return { ok: false, code: 'VALIDATION_ERROR' };
            }
            return { ok: false, code: response.status === 429 ? 'RATE_LIMITED' : 'RETRY', frozen: true };
          });
        }), timeout
      ]).catch(function () {
        return { ok: false, code: 'RETRY', frozen: true };
      }).finally(function () {
        clearTimeout(timer);
        active = null;
      });
      return active;
    }

    return {
      submit: submit,
      pendingPayload: function () { return pending ? JSON.parse(pending.body) : null; }
    };
  }

  scope.StarberInquiryTransport = { create: create };
})(typeof globalThis !== 'undefined' ? globalThis : window);
